import styled from 'styled-components';

const Container = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
`;

export default Container;
